import { render, staticRenderFns } from "./ClientsInformation.vue?vue&type=template&id=f1a374a4&"
import script from "./ClientsInformation.vue?vue&type=script&lang=js&"
export * from "./ClientsInformation.vue?vue&type=script&lang=js&"
import style0 from "./ClientsInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports